import React from 'react'

import * as S from './styles'

import Background from '../../components/shared/Background'
import CardCompany from '../../components/login/CardCompany'
import CardLogin from '../../components/login/CardLogin'

function Login () {
  const [cardToFront, setCardToFront] = React.useState('cardCompany')

  function handleSetCardLogin () {
    setCardToFront('cardLogin')
  }

  return (
    <>
      <Background />
      <S.FlexContainer>
        <S.ColLeft>
          <CardCompany active={cardToFront} onClick={() => setCardToFront('cardCompany')} />
        </S.ColLeft>
        <S.ColRight>
          <CardLogin active={cardToFront} onHandleSetCardLogin={handleSetCardLogin} />
        </S.ColRight>
        <input type={'hidden'} value={process.env.APP_ENV}/>
      </S.FlexContainer>
    </>
  )
}

export default Login
